module.exports = __webpack_public_path__ + "img/theme10.e41d4372.png";